import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Padlock(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08337 4.99992C5.08337 2.25237 7.25249 0.083252 10 0.083252C12.7476 0.083252 14.9167 2.25237 14.9167 4.99992V6.74989H16.0417C16.8011 6.74989 17.4167 7.3655 17.4167 8.12489V18.5416C17.4167 19.301 16.8011 19.9166 16.0417 19.9166H3.95837C3.19898 19.9166 2.58337 19.301 2.58337 18.5416V8.12489C2.58337 7.3655 3.19898 6.74989 3.95837 6.74989H5.08337V4.99992ZM5.08337 8.24992V8.24989H4.08337V18.4166H15.9167V8.24989H14.9167V8.24992H5.08337ZM13.4167 4.99992V6.74989H6.58337V4.99992C6.58337 3.0808 8.08092 1.58325 10 1.58325C11.9192 1.58325 13.4167 3.0808 13.4167 4.99992ZM10 11.5833C9.49378 11.5833 9.08337 11.9937 9.08337 12.4999C9.08337 13.0062 9.49378 13.4166 10 13.4166C10.5063 13.4166 10.9167 13.0062 10.9167 12.4999C10.9167 11.9937 10.5063 11.5833 10 11.5833ZM7.58337 12.4999C7.58337 11.1652 8.66535 10.0833 10 10.0833C11.3347 10.0833 12.4167 11.1652 12.4167 12.4999C12.4167 13.5728 11.7176 14.4823 10.7501 14.7979V15.8333C10.7501 16.2475 10.4143 16.5833 10.0001 16.5833C9.58589 16.5833 9.25011 16.2475 9.25011 15.8333V14.798C8.28254 14.4824 7.58337 13.5728 7.58337 12.4999Z",
    fill: "#595963"
  }));
}

export { Padlock };
//# sourceMappingURL=Padlock.js.map